import { LiquidityStakingDashboardPage } from "components/liquidity-staking/LiquidityStakingDashboardPage";
import { WalletModal } from "components/modals/WalletModal";
import { DashboardPage } from "pages/DashboardPage";
import { ErrorPage } from "pages/ErrorPage";
import { FeeConfigPage } from "pages/FeeConfigPage";
import { LayoutPage } from "pages/LayoutPage";
import { LiquidityStakingPage } from "pages/LiquidityStakingPage";
import { LoadingPage } from "pages/LoadingPage";
import { ManagePoolPage } from "pages/ManagePoolPage";
import { MyAssetsPage } from "pages/MyAssetsPage";
import { RegisterTokenPage } from "pages/RegisterTokenPage";
import { RewardPage } from "pages/RewardPage";
import { StakedAssetPage } from "pages/StakedAssetPage";
import { StakingConfigPage } from "pages/StakingConfigPage";
import { TestingConnect } from "pages/TestingConnect";
import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

export function App() {
  useEffect(() => {
    loadScripts()
  }, []);

  const loadScripts = async () => {
    let urls = [
      "/assets/vendor/js/helpers.js",
      "/assets/js/config.js",
      "/assets/vendor/libs/jquery/jquery.js",
      "/assets/vendor/libs/popper/popper.js",
      "/assets/vendor/js/bootstrap.js",
      "/assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.js",
      "/assets/vendor/js/menu.js",
      "/assets/js/main.js",
      "/assets/js/ui-popover.js",
      "/assets/js/vuplex.js",
      "https://buttons.github.io/buttons.js",
    ]

    for (const url of urls) {
      const id = Buffer.from(url).toString('hex')

      if (!document.getElementById(id)) {
        const script = document.createElement('script');
        script.id = id;

        const data = await fetch(url)
        const text = await data.text()
        script.innerHTML = text;
        document.body.appendChild(script);
      }
    }
  }


  return <Routes>
    <Route path="/" element={<LayoutPage />}>
      <Route index element={<DashboardPage />} />
      <Route path="/register-token" element={<RegisterTokenPage />} />
      <Route path="/:stakingAddress/pool" element={<ManagePoolPage />} />
      <Route path="/:stakingAddress/asset" element={<StakedAssetPage />} />
      <Route path="/:stakingAddress/config" element={<StakingConfigPage />} />
      <Route path="/:stakingAddress/reward" element={<RewardPage />} />
      <Route path="/fee-config" element={<FeeConfigPage />} />
      <Route path="/hybrid-staking" element={<LiquidityStakingPage />} />
      <Route path="/hybrid-staking/home" element={<LiquidityStakingDashboardPage />} />
      <Route path="/my-assets" element={<MyAssetsPage />} />
    </Route>

    <Route path="*" element={<ErrorPage />} />
    <Route path="/testing-connect" element={<TestingConnect />} />
  </Routes>
}
